import Firebase from 'firebase'
const firebaseApp = Firebase.initializeApp({
    apiKey: "AIzaSyBmr7-zv4OVMXmFx-WrdkMs9rQfoPzRuPI",
    authDomain: "content-flags.firebaseapp.com",
    databaseURL: "https://content-flags.firebaseio.com",
    projectId: "content-flags",
    storageBucket: "content-flags.appspot.com",
    messagingSenderId: "280774500227"
})
const db = firebaseApp.firestore()
export default db